<template>
  <main>
    <header-view>综合数据评估报告</header-view>

    <!-- 动态变化图 -->
    <waterfall-card
        v-if="zhDynamics.length > 0"
        title="身体综合检测动态图"
        :list="zhDynamics"
        labelKey="item_dict_name"
        simpleLabelKey="item_dict_name_simple"
        :valueKey="stackValueKey"
        stack="diff"
    ></waterfall-card>

    <!-- 身体综合平均值状态图 -->
    <waterfall-card
        v-if="zhAverage.length > 0"
        title="平均值状态图"
        :list="zhAverage"
        labelKey="item_dict_name"
        simpleLabelKey="item_dict_name_simple"
        :valueKey="avValueKey"
        colorKey="color"
    ></waterfall-card>

    <!-- 综合数据报告表 -->
    <table-card class="table" title="综合数据报告表" :columns="columns" :list="zhList" v-slot="row" tips @tip="interpret = true">
      <router-link :to="{ path: details[row.item_dict_type], query: { code: row.system_code, title: row.item_dict_name, color: row.color, ...query }}"></router-link>
    </table-card>

    <header-view>详细体质数据分析报告</header-view>

    <!-- 身体内脏检测动态图 -->
    <waterfall-card
        v-if="nzDynamics.length > 0"
        title="身体内脏检测动态图"
        :list="nzDynamics"
        labelKey="item_dict_name"
        simpleLabelKey="item_dict_name_simple"
        :valueKey="stackValueKey"
        stack="diff"
    ></waterfall-card>

    <!-- 身体内脏平均值状态图 -->
    <waterfall-card
        v-if="nzAverage.length > 0"
        title="身体内脏平均值状态图"
        :list="nzAverage"
        labelKey="item_dict_name"
        simpleLabelKey="item_dict_name_simple"
        :valueKey="avValueKey"
        colorKey="color"
    ></waterfall-card>

    <!-- 身体内脏数据报告表 -->
    <table-card class="table" title="身体内脏数据报告表" :columns="columns" :list="nzList" v-slot="row" tips @tip="interpret = true">
      <router-link :to="{ path: details[row.item_dict_type], query: { code: row.system_code, title: row.item_dict_name, color: row.color, ...query }}"></router-link>
    </table-card>

    <!-- 营养素检测动态图 -->
    <waterfall-card
        v-if="yyDynamics.length > 0"
        title="营养素检测动态图"
        :list="yyDynamics"
        labelKey="item_dict_name"
        simpleLabelKey="item_dict_name_simple"
        :valueKey="stackValueKey"
        stack="diff"
    ></waterfall-card>

    <!-- 营养素平均值状态图 -->
    <waterfall-card
        v-if="yyAverage.length > 0"
        title="营养素平均值状态图"
        :list="yyAverage"
        labelKey="item_dict_name"
        simpleLabelKey="item_dict_name_simple"
        :valueKey="avValueKey"
        colorKey="color"
    ></waterfall-card>

    <!-- 营养素数据报告表 -->
    <table-card class="table" title="营养素数据报告表" :columns="columns" :list="yyList" v-slot="row" tips @tip="interpret = true">
      <router-link :to="{ path: details[row.item_dict_type], query: { code: row.system_code, title: row.item_dict_name, color: row.color, ...query }}"></router-link>
    </table-card>

    <!-- 解读说明弹窗 -->
    <dialog-view v-model="interpret" class="interpret" title="解读说明">
      <span v-for="(item, index) in levels" :key="index"><i :style="{background: item.color}"></i>{{item.str}}</span>
    </dialog-view>
  </main>
</template>

<script>
  import HeaderView from "@/components/HeaderView";
  import WaterfallCard from "@/components/WaterfallCard";
  import TableCard from "@/components/TableCard";
  import {getReportComprehensiveAll} from "../net/api";
  import DialogView from "../components/DialogView";

  export default {
    name: "Overview",
    components: {DialogView, TableCard, WaterfallCard, HeaderView},

    data() {
      return {
        packageNo: '',
        checkcode: '',
        rand: '',

        // 详情页路由地址
        details: ['', '', '/details', '/tissue', '/nutrition'],

        // 通用态图列表数据关联项
        statusValueKey: {
          av: '均值',
          one: '初值',
          two: '终值',
        },

        stackValueKey: {
          one: '初值',
          two: '终值',
        },

        avValueKey: {
          av: '均值',
        },

        // 综合动态图
        zhDynamics: [],
        // 内脏动态图
        nzDynamics: [],
        // 营养素动态图
        yyDynamics: [],

        // 综合平均值状态图
        zhAverage: [],
        // 内脏平均值状态图
        nzAverage: [],
        // 营养素平均值状态图
        yyAverage: [],

        // 综合数据表
        zhList: [],
        // 内脏数据表
        nzList: [],
        // 营养素数据表
        yyList: [],

        // 列表关联项
        columns: {
          item_dict_name: '检测项目',
          one: '初值',
          two: '终值',
          diff: {
            name: '均值',
            value: (row) => {
              let val = row.two - row.one;
              return '<i class="arrow' + (val >= 0 ? ' up' : '') + '" style="background-color: ' + row.color + ';"></i><label>' + Number(row.av).toFixed(2) + '</label>';
            }
          }
        },
        // 详细数据评估表
        list: [],

        // 报告等级列表
        levels: [],

        // 解读说明弹窗
        interpret: false
      }
    },

    computed: {
      // 基础参数数据
      query() {
        return {
          packageNo: this.packageNo, rand: this.rand,  checkcode: this.checkcode
        }
      }
    },

    created() {
      const query = this.$router.currentRoute.query;
      this.packageNo = query.packageNo;
      this.checkcode = query.checkcode;
      this.rand = query.rand;

      this.syncPageData();
    },

    methods: {
      // 同步页面数据
      syncPageData() {
        // 获取报告数据
        getReportComprehensiveAll({
          packageNo: this.packageNo,
          rand: this.rand,
          checkcode: this.checkcode
        }).then((data) => {
          this.levels = data.colorData;
          this.zhDynamics = data.show_shenti_dongtaibianhua;
          this.nzDynamics = data.show_neizang_dongtaibianhua;
          this.yyDynamics = data.show_yingyang_dongtaibianhua;

          this.zhAverage = data.show_shenti_zhuangtaitu;
          this.nzAverage = data.show_neizang_zhuangtaitu;
          this.yyAverage = data.show_yingyang_zhuangtaitu;

          this.zhList = data.show_shenti_xiangxishuju;
          this.nzList = data.show_neizang_xiangxishuju;
          this.yyList = data.show_yingyang_xiangxishuju;


        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .table {
    ::v-deep {
      .arrow {
        display: block;
        width: 30px;
        height: 30px;
        border-radius: 10px;
        background-image: url("../assets/down.png");
        background-position: center;
        background-repeat: no-repeat;
        background-size: 18px 23px;

        &.up {
          background-image: url("../assets/up.png");
        }
      }

      label {
        display: flex;
        width: 80px;
        justify-content: flex-end;
      }
    }
  }
</style>